/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */
import { cloneDeep } from 'lodash';
import {
  RECEIVED_BANK_PROFILE,
  RECEIVED_CHANGE_UPDATE_BANK,
  RECEIVED_UPDATE_ADD_ASSOCIATIONS,
  RECEIVED_UPDATE_DELETE_ASSOCIATIONS,
  CLEAR_DELETE_ASSOCIATIONS,
  SELECT_ALL_DELETE_ASSOCIATIONS,
  CLEAR_ADD_ASSOCIATIONS,
  SELECT_ALL_ADD_ASSOCIATIONS,
  RECEIVED_BANK_VERIFICATIONS,
  RECEIVED_ELIGIBLE_AGREEMENTS_FOR_BANK,
  ERROR_CHALLENGE_DEPOSIT_VERIFICATION,
  RECEIVED_CHANGE_BANK_MODAL_STATE,
  RECEIVED_CHALLENGE_DEPOSIT_VERIFICATION,
  CLEAR_BANKS_IN_ERROR_CHALLENGE_DEPOSIT
} from './LinkedBankAccountsActions';

export const bankProfileInitialState = {
  bankAccounts: [],
  pendingVerifications: []
};

export const linkedBankAccountsReducer = (
  state = bankProfileInitialState,
  action
) => {
  if (action.type === RECEIVED_BANK_PROFILE) {
    return action.bankProfile;
  }
  return state;
};

export const bankAccountToUpdateReducer = (state = null, action) => {
  if (action.type === RECEIVED_CHANGE_UPDATE_BANK) {
    return action.bankAccount || state;
  }

  return state;
};

export const bankModalStateReducer = (state = 'add', action) => {
  if (action.type === RECEIVED_CHANGE_BANK_MODAL_STATE) {
    return action.modalState || state;
  }

  return state;
};

export const updatedAddAssociationsReducer = (state = [], action) => {
  const { type } = action;
  if (type === RECEIVED_UPDATE_ADD_ASSOCIATIONS) {
    let associations = cloneDeep(state);
    const {
      account: { accountId }
    } = action;
    if (accountId) {
      const index = associations.indexOf(accountId);
      if (index > -1) {
        associations.splice(index, 1);
        return associations;
      }
      associations.push(action.account.accountId);
      return associations;
    }
  }

  if (action.type === CLEAR_ADD_ASSOCIATIONS) {
    return [];
  }

  if (action.type === SELECT_ALL_ADD_ASSOCIATIONS) {
    const { accounts } = action;
    if (accounts) {
      return accounts.map((account) => {
        const { accountDescriptor } = account;
        if (accountDescriptor.accountId) {
          return accountDescriptor.accountId;
        }
      });
    }
  }
  return state;
};

export const updatedDeleteAssociationsReducer = (state = [], action) => {
  const { type } = action;
  if (type === RECEIVED_UPDATE_DELETE_ASSOCIATIONS) {
    let associations = cloneDeep(state);
    const {
      account: { accountId }
    } = action;
    if (accountId) {
      const index = associations.indexOf(accountId);
      if (index > -1) {
        associations.splice(index, 1);
        return associations;
      }
      associations.push(action.account.accountId);
      return associations;
    }
  }

  if (action.type === CLEAR_DELETE_ASSOCIATIONS) {
    return [];
  }

  if (action.type === SELECT_ALL_DELETE_ASSOCIATIONS) {
    const { accounts } = action;
    if (accounts) {
      return accounts.map((account) => {
        const { accountDescriptor } = account;
        if (accountDescriptor.accountId) {
          return accountDescriptor.accountId;
        }
      });
    }
  }
  return state;
};

export const bankVerificationsReducer = (state = [], action) => {
  const { type } = action;

  if (type === RECEIVED_BANK_VERIFICATIONS) {
    const { verifications } = action;
    if (verifications.length) {
      return verifications;
    }
    return state;
  }
  return state;
};

export const eligibleAgreementsForBankReducer = (state = [], action) => {
  const { type } = action;

  if (type === RECEIVED_ELIGIBLE_AGREEMENTS_FOR_BANK) {
    const { accounts } = action;
    if (accounts.length) {
      return accounts;
    }
    return state;
  }

  return state;
};

export const banksInErrorDepositVerificationReducer = (state = [], action) => {
  const { type } = action;

  if (type === ERROR_CHALLENGE_DEPOSIT_VERIFICATION) {
    let banksInError = cloneDeep(state);
    const {
      bankAccount: { uniqueKey }
    } = action;
    if (uniqueKey) {
      const index = banksInError.indexOf(uniqueKey);
      if (index > -1) {
        banksInError.splice(index, 1);
        return banksInError;
      }
      banksInError.push(action.bankAccount.uniqueKey);
      return banksInError;
    }
  }

  if (type === RECEIVED_CHALLENGE_DEPOSIT_VERIFICATION) {
    let banksInError = cloneDeep(state);
    const {
      bankAccount: { uniqueKey }
    } = action;
    if (uniqueKey) {
      const index = banksInError.indexOf(uniqueKey);
      if (index > -1) {
        banksInError.splice(index, 1);
        return banksInError;
      }
      return banksInError;
    }
  }

  if (type === CLEAR_BANKS_IN_ERROR_CHALLENGE_DEPOSIT) {
    return [];
  }

  return state;
};
